const paidServices = [
  { number: 'one', checked: false },
  { number: 'two', checked: false },
  { number: 'three', checked: false },
  { number: 'four', checked: false },
  { number: 'five', checked: false },
];

export default paidServices;
